import { useState, MouseEvent, useEffect } from "react"
import { FilterBarType } from "../FilterBar"
import { ReactComponent as CalendarIcon } from '../../../assets/Icons/adornments/Date.svg';
import FilterBarBtn from "./FilterBarBtn";
import { ClickAwayListener, Grow, Paper, Popper } from "@mui/material";

import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { useTheme } from '@mui/material/styles';

export default function DateRange({
    filter,
    setFilterValue,
    anchorEl,
    handleOpen,
    handleClose,
}: {
    filter: {
        filters: FilterBarType[],
        groupKey?: string,
        value: string | string[] | { [key: string]: Dayjs | null } | null,
    },
    setFilterValue: (filters: FilterBarType[], value: string | string[] | { [key: string]: Dayjs | null } | null) => void,
    anchorEl: null | HTMLElement,
    handleOpen: (event: MouseEvent<HTMLButtonElement>) => void,
    handleClose: () => void,
}) {
    const [ dateRange, setDateRange ] = useState<{
        start: Dayjs | null,
        end: Dayjs | null,
    }>({
        start: null,
        end: null,
    });

    useEffect(() => {
        if (filter.value) {
            const dates = filter.value as {
                start: Dayjs | null,
                end: Dayjs | null,
            };

            setDateRange(dates);
        } else {
            setDateRange({
                start: null,
                end: null,
            })
        }
    }, [filter.value]);
    

    const handleDateChange = (e:any, type: 'start' | 'end') => {
        setDateRange({
            ...dateRange,
            [type]: e,
        });
    };

    const undoDateRange = () => {
        handleClose();
        const dates = filter.value as {
            start: Dayjs,
            end: Dayjs,
        } | null;

        setDateRange(dates ? dates : {
            start: null,
            end: null,
        });
    }

    const resetDateRange = () => {
        handleClose();
        setDateRange({
            start: null,
            end: null,
        });
        setFilterValue(filter.filters, null);
    }

    const applyDateRange = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        setFilterValue(filter.filters, dateRange);
        handleClose();
    };

    const displayDateValue = (value: {
        start: Dayjs | null,
        end: Dayjs | null,
    } | null) => {
        if (!value) {
            return null;
        } else {
            if (!value.start && !value.end) {
                return null;
            } else {
                return `${value.start ? value.start.format('MM/DD/YYYY') : ''} - ${value.end ? value.end.format('MM/DD/YYYY') : ''}`
            }
        }
    }

    const theme = useTheme();


    return (
        <>
            <FilterBarBtn 
                label={filter.filters[0].label}
                value={displayDateValue(filter.value as { start: Dayjs | null, end: Dayjs | null } | null)}
                icon={<CalendarIcon />}
                isOpen={Boolean(anchorEl && anchorEl.id === filter.filters[0].param)}
                handleOpen={handleOpen}
                handleClose={handleClose}
                resetFn={resetDateRange}
                id={filter.filters[0].param}
            />

            <Popper open={Boolean(anchorEl && anchorEl.id === filter.filters[0].param)} anchorEl={anchorEl} placement="bottom-start" sx={{ zIndex: 2000 }} transition>
                {({ TransitionProps }) => (
                <Grow {...TransitionProps} in={Boolean(anchorEl && anchorEl.id === filter.filters[0].param)} style={{ transformOrigin: '0 0 0' }}>
                <Paper
                    sx={{
                        borderRadius: '8px',
                        overflow: 'hidden',
                        marginTop: '8px',
                        boxShadow: theme.shadows[8],
                    }}
                >
                    <ClickAwayListener onClickAway={undoDateRange}>
                        <div className="w-full flex justify-start items-start bg-white">
                            {/* <div className="flex flex-col gap-3 justify-start items-stretch p-4">
                                {ranges.map(range => (
                                    <button className="w-full flex justify-start items-center p-2 text-[12px]">{range.label}</button>
                                ))}
                            </div> */}
                            <div className="flex flex-col justify-start items-stretch h-full">

                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="flex justify-center items-center gap-2 p-4">
                                        <div className="flex flex-col justify-start items-stretch gap-2">
                                           <DateCalendar value={dateRange.start ? dayjs(dateRange.start) : null} onChange={(e:any) => handleDateChange(e, 'start')}/>
                                        </div>
                                        <div className="flex flex-col justify-start items-stretch gap-2">
                                            <DateCalendar value={dateRange.end ? dayjs(dateRange.end) : null} onChange={(e:any) => handleDateChange(e, 'end')}/>
                                        </div>
                                    </div>
                                </LocalizationProvider>

                                <div className="flex justify-end items-center gap-2 p-4 border-t border-light-outline">
                                    <button onClick={resetDateRange} className="px-4 py-3 text-primary font-medium text-[12px]">Reset</button>
                                    <button onClick={applyDateRange} className="px-4 py-3 text-white font-medium bg-primary rounded-lg text-[12px]">Apply</button>
                                </div>

                            </div>
                        </div>
                    </ClickAwayListener>
                </Paper>
                </Grow>
                )}
            </Popper>
        </>
    )
}